module.exports = __webpack_public_path__ + "img/W7026-full.45b85f70.jpg";